export const clearEntities: EntityChanges<any> = {
	changeType: 'remove',
	entities: [],
};

export interface EntityChanges<T> {
	changeType: 'created' | 'deleted' | 'updated' | 'set' | 'remove';
	entities: T[];
}
